module.exports = __webpack_public_path__ + "static/img/37饲料.8502577.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/37饲料.jpg
// module id = w0DA
// module chunks = 0